import TextInputMaskedServerError from '@perpay-web/components/higher-order/WithFieldServerErrors/TextInputMaskedServerError';

const PhoneInput = ({
    name = 'phoneNumber',
    label = 'Phone Number',
    ...rest
}) => (
    <TextInputMaskedServerError
        name={name}
        id={name}
        label={label}
        format='(###) ### ####'
        placeholder='(###) ### ####'
        type='tel'
        prefix='+1'
        autoComplete='tel'
        {...rest}
    />
);

export default PhoneInput;
